import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_CHAT } from './demoFixtures';

const C = DEMO_CHAT;
const MAX = Math.max(...C.rows.map((r) => r.count));

// 0 질문 입력 → 1 생각 중 → 2 그래프 → 3(완성) 정리 문장 + 듣기
const STEPS = [typingDuration(C.question, 2, 30), 900, 1500];

const ChatAnswerDemo = ({ surface = 'home', title = 'AI 채팅', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'chat', autoStart });
  const { phase, done, paused } = player;
  const question = useTypedText(C.question, { active: phase === 0, complete: phase > 0, paused, charsPerTick: 2, tickMs: 30 });

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-chat">
        <div className="wqdemo-bubble-user">
          {question}
          {phase === 0 && <span className="wqdemo-cursor" style={{ background: '#ffffff' }} />}
        </div>
        {phase >= 1 && (
          <div className="wqdemo-answer wqdemo-in">
            {phase === 1 ? (
              <>
                <div className="wqdemo-skeleton" style={{ width: '70%' }} />
                <div className="wqdemo-skeleton" style={{ width: '50%' }} />
              </>
            ) : (
              <>
                <div>{C.intro}</div>
                {phase >= 2 && (
                  <div className="wqdemo-chart wqdemo-in" aria-hidden="true">
                    {C.rows.map((r) => (
                      <div key={r.band} className="wqdemo-chart-row">
                        <span>{r.band}</span>
                        <span className="wqdemo-chart-track">
                          <span
                            className="wqdemo-chart-fill"
                            style={{ width: `${(r.count / MAX) * 100}%` }}
                          />
                        </span>
                        <b>{r.count}</b>
                      </div>
                    ))}
                  </div>
                )}
                {done && (
                  <>
                    <div className="wqdemo-in" style={{ marginTop: 8 }}>{C.outro}</div>
                    <div className="wqdemo-answer-actions">
                      <span className="wqdemo-btn is-soft">복사</span>
                      <span className="wqdemo-btn is-soft">답변 듣기</span>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </DemoFrame>
  );
};

export default ChatAnswerDemo;
